import i18nRemote from '../plugins/i18next-remote'
import flowSettings from './config/settings'

import '../../static/remote/intro.mp4'
import '../../static/remote/intro-desktop.mp4'

const createElementWithClassAndText = (type = 'span', className, text = '') => {
  const element = document.createElement(type)
  if (className) {
    element.classList.add(className)
  }
  // textContent achieve the same result but it doesn’t have security issues like innerHTML as it doesn’t parse HTML like innerText. Besides, it is also light due to which performance increases.
  element.textContent = text
  return element
}

const remoteStatus = {
  frameHolder: null,
  remoteStatusHolder: document.createElement('div'),
  device: null,
  host: null,
  remoteConfig: flowSettings.remoteConfig,
  showConnected: false,

  openFrame (frameHolder, device, host, language, isPlayground) {
    if (language) {
      i18nRemote.changeLanguage(language)
    }
    this.frameHolder = frameHolder
    this.device = device
    this.host = host
    this.insertStatusBar()
  },

  closeFrame () {
    if (!this.remoteStatusHolder.parentNode) return
    this.frameHolder.classList.remove('show-module-remote')
    this.frameHolder.classList.remove('show-remote-loader')
    this.frameHolder.classList.remove('remove-bg-overlay')
    this.remoteStatusHolder.parentNode.removeChild(this.remoteStatusHolder)
  },
  insertConnectingText () {
    const connectingNode = createElementWithClassAndText('div', 'remote-status-connecting', i18nRemote.t('connecting_to', { domain: this.remoteConfig.notificationDomain || flowSettings.partnerName }))
    const dotsSpan = createElementWithClassAndText('span', 'dots', '.')

    connectingNode.appendChild(dotsSpan)

    this.remoteStatusHolder.appendChild(connectingNode)
  },
  insertConnectedText () {
    const connectedNode = createElementWithClassAndText('div', 'remote-status-connected')
    const connectedTextSpan = createElementWithClassAndText('span', 'connected-text', i18nRemote.t('connected_to',{ domain: this.remoteConfig.notificationDomain || flowSettings.partnerName }))
    const domainTextSpan = createElementWithClassAndText('span', 'brand-name', this.remoteConfig.notificationDomain || flowSettings.partnerName)

    connectedNode.appendChild(connectedTextSpan)
    connectedNode.appendChild(domainTextSpan)
    this.remoteStatusHolder.appendChild(connectedNode)

    setTimeout(() => {
      this.remoteStatusHolder.classList.add('show-connected-brand-name')
    }, 1800)
  },
  showConnectedNotification () {
    if (this.showConnected) return

    setTimeout(() => {
      this.remoteStatusHolder.classList.add('show-connected')
      this.insertConnectedText()
    }, 1000)

    this.showConnected = true
  },
  insertStatusBar () {
    this.remoteStatusHolder.classList.add('remote-status')

    this.insertConnectingText()

    this.frameHolder.appendChild(this.remoteStatusHolder)
  }

}

export default remoteStatus



// WEBPACK FOOTER //
// ./src/partners/remote-status.js